import actionTypes from '../constants/action-types';

const pageContainerSelector = (state = null, action) => {
  if (action.type !== actionTypes.SET_PAGE_CONTAINER_SELECTOR) {
    return state;
  }

  return action.payload.pageContainer;
};

export default pageContainerSelector;
